
import ValidatorContext from "formvalidation/FormContext";
import { useValidators } from "formvalidation/hooks";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { SectionTemplate } from "./SectionTemplate";
import { EditNewSection } from "./types";

type LocalFormSectionTemplateProps = {
  onSuccess: () => void;
  sections: Array<EditNewSection>;
}

export const LocalFormSectionTemplate = (props: LocalFormSectionTemplateProps) => {
  const { onSuccess, sections } = props;
  const [isLoading, setIsLoading] = useState(false);

  const validators = useValidators();

  const onSubmit = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const validatorResult = await validators.validateAll();

    if (validatorResult.hasErrors) {
      setIsLoading(false);
      return;
    }

    onSuccess();
  }

  const mappedSections = sections.map((section) => {
    if (section.type === "custom") {
      return section;
    }

    return {
      ...section,
      fields: section.fields.map((field) => ({
        ...field,
        isEmpty: false,
        render: field.renderEditNew,
        inPageEdit: undefined,
      })),
    }
  });

  const Footer = () => <div className="flex">
    <div className="grow1" />
    <Button
      primary
      type="submit"
      loading={isLoading}
      disabled={isLoading}
    >
      {RESX.Buttons.btnSave}
    </Button>
  </div>

  return <ValidatorContext settings={validators.validatorSettings}>
    <form onSubmit={(e) => {
      e.preventDefault();

      // Stop propagation because we can have a form in a form (e.g. form > modal > form)
      e.stopPropagation();
      onSubmit();
    }}>
      <SectionTemplate
        isInPageEditable={false}
        noPanels
        compact
        sections={[...mappedSections, {
          type: "custom",
          key: "submit",
          render: () => <Footer key="saveButton" />
        }]}
      />
    </form>
  </ValidatorContext>
}